module.exports = __webpack_public_path__ + "static/media/PrescriptionApp-card-logo.dc569b25.png";